import * as React from 'react';
import { useFragment } from 'react-relay';
import { textBlockFragment } from './TextBlock.relay';
import { textBlockClassName } from './lib/TextBlockStyles';
import type { TextBlockPropsType } from './types';

const TextBlock: React.FC<TextBlockPropsType> = ( props: TextBlockPropsType ) => {
    const contentBlock = useFragment( textBlockFragment, props.contentBlock );

    return (
        <div className={textBlockClassName}>
            {contentBlock.title !== '' && contentBlock.title !== null && <h2>{contentBlock.title}</h2>}
            <p>{contentBlock.text}</p>
        </div>
    );
};

export { TextBlock };
